"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstructionDocumentType = void 0;
var ConstructionDocumentType;
(function (ConstructionDocumentType) {
    ConstructionDocumentType["FIELD_NOTE"] = "FIELD_NOTE";
    ConstructionDocumentType["DAILY_REPORT"] = "DAILY_REPORT";
    ConstructionDocumentType["RFI"] = "RFI";
    ConstructionDocumentType["SUBMITTAL"] = "SUBMITTAL";
    ConstructionDocumentType["SUBMITTAL_PACKAGE"] = "SUBMITTAL_PACKAGE";
    ConstructionDocumentType["CHANGE_ORDER"] = "CHANGE_ORDER";
    ConstructionDocumentType["PURCHASE_ORDER"] = "PURCHASE_ORDER";
})(ConstructionDocumentType = exports.ConstructionDocumentType || (exports.ConstructionDocumentType = {}));
